export default __webpack_public_path__ + "static/media/down.ccaf0fa4.svg";